import { useEffect } from "react";
import { useFailures } from "@/stores/failures";

export function Toast() {
  const failures = useFailures((s) => s.failures);
  const dismiss = useFailures((s) => s.dismissFailure);

  useEffect(() => {
    if (failures.length === 0) return;
    const timers = failures.map((f) =>
      window.setTimeout(() => dismiss(f.id), 5000),
    );
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [failures, dismiss]);

  if (failures.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 sm:max-w-sm w-[min(20rem,calc(100vw-2rem))]">
      {failures.map((f) => (
        <div
          key={f.id}
          role="alert"
          className="rounded-md bg-slate-900 text-slate-50 shadow-lg ring-1 ring-slate-700 px-3 py-2 text-sm flex items-center gap-3"
        >
          <span className="flex-1">{f.message}</span>
          {f.retry && (
            <button
              type="button"
              onClick={() => { f.retry?.(); dismiss(f.id); }}
              className="text-sky-300 hover:text-sky-200 font-medium"
            >
              {f.retryLabel ?? "Повторить"}
            </button>
          )}
          <button
            type="button"
            aria-label="Закрыть"
            onClick={() => dismiss(f.id)}
            className="text-slate-400 hover:text-slate-200"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
